import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { findDOMNode } from 'react-dom';
import OverviewMap from 'ol/control/OverviewMap';
import { getMap } from '../mapStore';
export class MapOverviewPreview extends React.PureComponent {
    control;
    componentDidMount() {
        // eslint-disable-next-line react/no-find-dom-node
        const target = findDOMNode(this);
        const map = getMap(this.props.mapIdent);
        if (!map)
            return;
        this.control = new OverviewMap({
            target,
            view: map.getView().getClone(),
            layers: this.props.layers,
            collapsed: true,
            collapsible: false,
        });
        map.addControl(this.control);
    }
    componentWillUnmount() {
        const map = getMap(this.props.mapIdent);
        map && map.removeControl(this.control);
    }
    render() {
        return _jsx("div", { className: 'rpx-mapOverview' });
    }
}
//# sourceMappingURL=preview.js.map